import { useTranslation } from 'react-i18next';

import { AgreementReadModel, useDeleteAgreementsByIdMutation } from '@client/api';
import { Button, Modal, ModalFooter } from '@client/toolkit';
import { DeleteConfirmationModalContent } from '../../../../components/delete-confirmation-modal-content/delete-confirmation-modal-content';

interface AgreementDeleteModalProps {
  agreement: AgreementReadModel;
  open: boolean;
  onDeleteFulfilled: () => void;
  onCancel: () => void;
}

export const AgreementDeleteModal = ({ agreement, open, onCancel, onDeleteFulfilled }: AgreementDeleteModalProps) => {
  const { t: tCommon } = useTranslation();
  const { t: tGlobal } = useTranslation('global');

  const [deleteAgreement, { isLoading: isDeleting }] = useDeleteAgreementsByIdMutation();

  const handleDelete = async () => {
    if (agreement?.id == null) return;
    try {
      await deleteAgreement({ id: agreement.id });
    } catch (e) {
      return;
    }
    onDeleteFulfilled();
  };

  const handleClose = () => {
    onCancel();
  };

  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose} closeDisabled={isDeleting}>
      <DeleteConfirmationModalContent name={tGlobal('entity.agreement')} />
      <ModalFooter className="justify-center">
        <Button color="danger" onClick={handleDelete} progressing={isDeleting}>
          {tCommon('delete')}
        </Button>
        <Button color="primary-dark" onClick={handleClose}>
          {tCommon('cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
